export default __webpack_public_path__ + "static/humberside-police-5ea89127b7f1d5008a69c023e543b67a.png";